"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PACKAGES;
(function (PACKAGES) {
    PACKAGES["API_CLIENT"] = "@8base/api-client";
    PACKAGES["APOLLO_CLIENT"] = "@8base/apollo-client";
    PACKAGES["APOLLO_LINKS"] = "@8base/apollo-links";
    PACKAGES["APP_PROVIDER"] = "@8base/app-provider";
    PACKAGES["REACT_AUTH"] = "@8base/react-auth";
    PACKAGES["AUTH"] = "@8base/auth";
    PACKAGES["CRUD"] = "@8base/crud";
    PACKAGES["FILE_INPUT"] = "@8base/file-input";
    PACKAGES["FORMS"] = "@8base/forms";
    PACKAGES["PERMISSIONS_PROVIDER"] = "@8base/permissions-provider";
    PACKAGES["TABLE_SCHEMA_PROVIDER"] = "@8base/table-schema-provider";
    PACKAGES["UTILS"] = "@8base/utils";
    PACKAGES["VALIDATE"] = "@8base/validate";
    PACKAGES["API_TOKEN_AUTH_CLIENT"] = "@8base/api-token-auth-client";
    PACKAGES["WEB_AUTH0_AUTH_CLIENT"] = "@8base/web-auth0-auth-client";
    PACKAGES["WEB_COGNITO_AUTH_CLIENT"] = "@8base/web-cognito-auth-client";
})(PACKAGES = exports.PACKAGES || (exports.PACKAGES = {}));
//# sourceMappingURL=packages.js.map